import { render, staticRenderFns } from "./SysMessageModal.vue?vue&type=template&id=256950d3&scoped=true&"
import script from "./SysMessageModal.vue?vue&type=script&lang=js&"
export * from "./SysMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256950d3",
  null
  
)

export default component.exports